module.exports = {
      id: "icons:spinner-solid-usage",
      viewBox: "0 0 512 512",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:spinner-solid-usage",
      toString: function () {
        return this.url;
      }
    }